export const types = {
    SET_ACTIVE_TAB: 'SET_ACTIVE_TAB',
    ADD_TAB: 'ADD_TAB',
    REMOVE_TAB: 'REMOVE_TAB',
    SET_DATA_TAB: 'SET_DATA_TAB',
}